module.exports = __webpack_public_path__ + "src/images/products/trendsetter/121_Baseball Hat.png";